import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { Button, SaveButton, Text } from '@adsk/bim360-matrix-react-components';
import AnimateHeightPopUp from '../../AnimateHeightPopUp';

class DeletePushpinPopUp extends PureComponent {
  constructor(props) {
    super(props);
    this.closeLearnMoreModal = this.closeLearnMoreModal.bind(this);
  }

  closeLearnMoreModal() {
    this.setState({ showLearnMoreModal: false });
  }

  renderContent() {
    const entityName = T.translate('rfis.label_capitalized');
    const title = T.translate('issueAttributes.document.deletePushpinConfirmationTitle', { entityName });
    const message = T.translate('issueAttributes.document.deletePushpinConfirmationDescription', { entityName });
    return (
      <div className="PushpinVisibilityPopUp__content">
        <div className="PushpinVisibilityPopUp__content-header">{title}</div>
        <div className="PushpinVisibilityPopUp__content-text">
          <Text>{message}</Text>
        </div>
      </div>
    );
  }

  renderFooter() {
    const { isDeletingPushpin, onDelete, onCancel } = this.props;
    const confirmationButtonLabel = T.translate('delete');
    const cancelButtonLabel = T.translate('navigation.cancel');
    const savingText = T.translate('deleting');

    return (
      <div className="PushpinVisibilityPopUp__footer">
        <Button
          key="cancelButton"
          styleType={Button.StyleType.LINK_SECONDARY}
          onClick={onCancel}
          disabled={isDeletingPushpin}
        >
          {cancelButtonLabel}
        </Button>
        <SaveButton
          key="saveButton"
          onSave={onDelete}
          isSaving={isDeletingPushpin}
          saveText={confirmationButtonLabel}
          savingText={savingText}
        />
      </div>
    );
  }

  render() {
    return (
      <AnimateHeightPopUp isOpen={this.props.isOpen}>
        <div className="PushpinVisibilityPopUp">
          {this.renderContent()}
          {this.renderFooter()}
        </div>
      </AnimateHeightPopUp>
    );
  }
}

DeletePushpinPopUp.displayName = 'PushpinVisibilityPopUp';

DeletePushpinPopUp.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isDeletingPushpin: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DeletePushpinPopUp;
